const ViewContainer = require('client/src/view-container');
const _ = require('core/src/utils/legacy');
const onDOMElementsResized = require('client/src/utils/onDOMElementsResized')

const { jsPanel } = require('jspanel4/es6module/jspanel.min');
require('jspanel4/es6module/jspanel.min.css');
require('./container-content.scss');

const CONTAINER_SELECTOR = '#content[role="view-area"]';

const offsets = [];
const margin = {
	right: 10,
	bottom: 10
};


// Remove jsPanel key modifier after some time to prevent locking when you switch browse window/tab using key combinations
let jsPanelModifierRemoveTimeout;
document.addEventListener('keydown', function (e) {
	jsPanelModifierRemoveTimeout = setTimeout(
		() => {
			jsPanel.modifier = false;
		},
		5000
	);
});

const containerDefinition = {
	build: function(containerID, containerData, classes) {
		let height 	= _.get(containerData, 'height', 400);
		let width 	= _.get(containerData, 'width', 500);
		let manualResized = false;

		const nextOffset = {
			x: 0,
			y: 0
		};
		const inserted = _.find(offsets, function(panel, offset) {
			if(panel === undefined) {
				offsets[offset] = containerID;
				return true;
			}
			nextOffset.x += 30;
			nextOffset.y += 30;
		});
		if(!inserted) {
			offsets.push(containerID);
		}

		const config = {
			id: containerID,
			container: CONTAINER_SELECTOR,
			css: {
				panel: "card",
				headerbar: "card-header border-0",
				content: "card-body",
			},
			headerControls: {
				size: "xs",
				normalize: "hide",
				maximize: "remove"
			},
			dragit: {
				containment: [0, undefined, undefined, 0]
			},
			resizeit: {
				containment:  [0, undefined, undefined, 0],
				stop: () => {
					manualResized = true;
					this.resize();
				}
			},
			// By default jsPanels have an outside drag/resize border zone of 9px that is invisible
			// If the panel is maximized fully (without the bellow margin) this zone will cause scrollbars to appear on the containing div.
			contentSize: {width, height},
			theme: 'none',
			callback: [
				panel => {
					panel.style["background-color"] = null;
				},
				panel => {
					const hdr = panel.querySelector('.jsPanel-hdr');
					if (!hdr) {
						return;
					}

					hdr.style = null;
				},
				panel => {
					const titleBar = panel.querySelector('.jsPanel-titlebar');
					if (!titleBar) {
						return;
					}

					titleBar.style["font-size"] = null;

					titleBar.addEventListener("dblclick", (event) => {
						switch (panel.status) {
							case "normalized":
								panel.maximize();
								break;
							case "maximized":
								panel.normalize();
						}
					});
				}
			],
			position: {
				my: 'left-top',
				at: 'left-top',
				offsetY: nextOffset.y,
				offsetX: nextOffset.x
			},
			onmaximized: () => {
				panel.setControlStatus("normalize", "hide");
				if (containerData.scrollOnMaximized) {
					containerContent.css({
						height: 'inherit'
					});
				}

				// Hide resize handles to prevent scrollbar to appear on default container
				$(panel).find('.jsPanel-resizeit-handle').hide();

				this.resize();
				this.updateState('state', ViewContainer.State.MAXIMIZED);
			},
			onnormalized: (panel) => {
				panel.setControlStatus("normalize", "hide");
				if (containerData.scrollOnMaximized) {
					containerContent.css({
						height: ''
					});
				}
				if (manualResized) {
					this.resize();
				} else {
					containerDefinition.setSize(panel, width, height);
				}

				// Show resize handles appear
				$(panel).find('.jsPanel-resizeit-handle').show();

				this.updateState('state', ViewContainer.State.NORMALIZED);
			},
			onbeforeminimize: (panel) => {
				panel.setControlStatus("normalize", "show");
				return true;
			},
			onminimized: (panel) => {
				this.updateState('state', ViewContainer.State.MINIMIZED);
			},
			onsmallified: () => {
				this.updateState('state', ViewContainer.State.COLLAPSED);
			},
			onunsmallified: () => {
				if(this.$element[0].status === "maximized") {
					this.updateState('state', ViewContainer.State.MAXIMIZED);
				} else {
					this.updateState('state', ViewContainer.State.NORMALIZED);
				}
			},
			onclosed: () => {
				// set to prevent error on double closing
				this.jsPanelClosed = true;
				this.close('user');
				document.removeEventListener('jspanelresizestop', this.resizedHandler);
			}
		};
		const panel = jsPanel.create(config);
		panel.id = containerID;

		// this.element is not assigned yet during build, so pass the panel explicitly
		this._setMenu(panel, this.getMenuConfig(containerData));

		this.resizedHandler = (ev) => {
			if (panel !== ev.panel) {
				return;
			}  

			this.updateState('height', ev.panel.clientHeight);
			this.updateState('width', ev.panel.clientWidth);
		}

		document.addEventListener('jspanelresizestop', this.resizedHandler);

		this.containerResizeObserver = onDOMElementsResized(
			$(CONTAINER_SELECTOR),
			(ev) => {
				if (panel.status !== 'maximized') return;
				let oldZindex = panel.style.zIndex;
				panel.maximize();
				panel.style.zIndex = oldZindex;
			}
		);

		const containerContent = $('<div class="container-content">');
		containerContent.addClass(classes.join(' '));
		containerContent.addClass('container-fixed-height');
		panel.content.appendChild(containerContent[0]);

		this.classes = classes;
		return panel;
	},
	attachTo: function(area) {
		// Not necessary, jsPanel does that on build
	},
	setTitle: function(panel, title) {
		if(!_.def(title)) title = ' ';
		panel.setHeaderTitle(title);
	},
	setMenu: function(panel, config) {
		const headerbar = panel.headerbar;
		if (! headerbar) {
			return;
		}

		const existing = headerbar.querySelector('.container-menu-button');
		if (existing) {
			existing.remove();
		}
		if (! config) {
			return;
		}

		// Deliberately not a jsPanel header control: it is inserted into the header bar as a
		// regular button, just before the control bar, so it stays visible when the window
		// controls (smallify/normalize/maximize/close) are hidden. The control bar is a
		// sibling of the title bar, and only the title bar is a drag handle, so this does
		// not interfere with dragging the panel.
		headerbar.insertBefore(this.buildMenuButton(config)[0], panel.controlbar);
	},
	close: function(panel) {
		this.containerResizeObserver.disconnect();

		// trigger remove on other views that are inside the panel so they close
		if (panel instanceof Element) {
			$(panel).find('.graphileon-container').trigger('remove');
		}

		if (! this.jsPanelClosed) {
			panel.close();
		}

		_.find(offsets, function(containerID, offset) {
			if(containerID === panel.id) {
				offsets[offset] = undefined;
				return true;
			}
		});
	},
	setSize: function(panel, width, height) {
		// if we send width as `undefined` to the panel resizer, the method using the height for width.
		const size = containerDefinition.getFinalPanelSize(width, height);
		if ( size.width && size.height )
			panel.resize(size);
		else if ( size.width )
			panel.resize({width: size.width});
		else if ( size.height )
			panel.resize({height: size.height});
	},
	moveToFront: function(panel) {
		// to bring to front we firstly need tosend to the back
		panel.style.zIndex = 0;
		jsPanel.resetZi();
		panel.front();
	},
	moveToBack: function(panel) {
		if("minimized" === panel.status) {
			return;
		}
		panel.style.zIndex = 0;
		jsPanel.resetZi();
	},
	getInnerSize: function(panel) {
		if(!_.isObject(panel)) {
			return {width: undefined, height: undefined};
		}
		return {
			width: panel.clientWidth,
			height: panel.clientHeight
		};
	},
	setState: function(panel, state) {
		switch(state) {
			case ViewContainer.State.MAXIMIZED: panel.maximize(); break;
			case ViewContainer.State.MINIMIZED: panel.minimize(); break;
			case ViewContainer.State.COLLAPSED: panel.smallify(); break;
			default: panel.normalize(); break;
		}
	},
	focus: function(panel) {
		panel.front();
	},
	getFinalPanelSize: function(width, height) {
		let size = {
			width,
			height
		};

		if (_.endsWith(width, '%') || _.endsWith(width, 'vw')) {
			size.width = () => {
				return `calc(${width} - ${margin.right}px)`;
			};
		}
		if (_.endsWith(height, '%') || _.endsWith(height, 'vh')) {
			size.height = () => {
				return `calc(${height} - ${margin.bottom}px)`;
			};
		}

		return size;
	}
};

module.exports = containerDefinition;
